export const QUEUE_ACTION_SOURCE_PREFIX = 'pipesv2://queue-action';

export function isQueueActionSource(source?: string | null): boolean {
  if (typeof source !== 'string') {
    return false;
  }

  return source.startsWith(QUEUE_ACTION_SOURCE_PREFIX);
}
